import * as React from 'react';
import api from "../utils/api";
import * as util from "../utils/util";
import historyStore from "../store/historyStore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Slider, { SliderValueLabelProps } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Slide, { SlideProps } from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import MuiInput from '@mui/material/Input';

import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const Input = styled(MuiInput)`
  width: 100px;
`;

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

function ValueLabelComponent(props: SliderValueLabelProps) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

export default function HistorySliderInput(props: any) {
  const navigate = useNavigate();
  // const storeData: any = historyStore();
  const [value, setValue] = React.useState(0);
  const [state, setState] = React.useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade,
  });

  useEffect(() => {
    setValue(props.info.value);
  }, [props.info.value]);

  const handleClick = (
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >,
  ) =>
    () => {
      setState({
        open: true,
        Transition,
      });
    };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
  };

  const handleSave = () => {
    setState({
      ...state,
      open: false,
    });
    props.handleComplete(value);
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value === '' ? 0 : Number(event.target.value));
  };


  const action = (
    <React.Fragment>
      <Box sx={{}}>
        <Stack >
          <Typography
            sx={{
              color: '#333',
              fontSize: 18,
              fontWeight: 700,
              textAlign: 'center',
              mb: '20px',
              borderBottom: '1px solid #ddd',
              pb: 2
            }}
          >
            {props.info.title}
          </Typography>
        </Stack>


        <Stack direction={'row'} justifyContent={'center'} >
          <IconButton aria-label="remove" sx={{ width: '10%', textAlign: 'center' }}
            onClick={() => setValue((prev: any) => prev > 0 ? prev - 1 : prev)}>
            <RemoveCircleOutlineIcon sx={{ color: '#f54d4d', fontSize: 30 }} />
          </IconButton>
          <Input
            value={value}
            onChange={handleInputChange}
            inputProps={{
              step: 1,
              type: 'number',
            }}
            sx={{
              color: '#333',
              fontWeight: 700,
              fontSize: 25,
              mb: 2,
              '& input':
                { textAlign: 'center', }
            }}
          />
          <IconButton aria-label="add" sx={{ width: '10%', textAlign: 'center' }} 
            onClick={() => setValue((prev: any) => prev < props.info.max ? prev + 1 : prev)}>
            <AddCircleOutlineIcon sx={{ color: '#5d86ff', fontSize: 30 }} />
          </IconButton>
        </Stack>



        <Stack direction={'column'}>
          {/* <Typography
            sx={{
              color: '#333',
              fontWeight: 700,
              fontSize: 25,
              textAlign: 'center',
              mb: 2
            }}
          >
            {util.formatComma(value)}
          </Typography>
           */}



          <IOSSlider
            value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            valueLabelDisplay="on"
            max={props.info.max}
            defaultValue={value}
          />



          <Typography
            sx={{
              color: '#999',
              fontSize: 12,
              textAlign: 'right',
              mt: 1
            }}
          >
            {props.info.unit}
          </Typography>
        </Stack>
      </Box>
      <Box sx={{ p: 0, }}>
        <Button onClick={handleSave} sx={bottomBtn}>
          저장
        </Button>
      </Box>
    </React.Fragment>
  );



  return (
    <Stack sx={editbtn} >
      <EditButton onClick={handleClick(SlideTransition)}>{props.info.btnTitle}</EditButton>
      <Snackbar
        open={state.open}
        onClose={handleClose}
        TransitionComponent={state.Transition}
        message={action}
        key={state.Transition.name}
        sx={{
          left: '0 !important', right: 0, bottom: '0 !important', width: '100%',
          '& .MuiSnackbarContent-root': {
            bgcolor: '#fff',
            display: 'block',
            width: '100%',
            padding: '15px',
            boxSizing: 'border-box',
            borderRadius: '20px 20px 0 0',
            boxShadow: '0px -3px 8px 2px rgba(0,0,0,.3)'
          }
        }}
      />
    </Stack>
  );
}

const IOSSlider = styled(Slider)({
  width: '95%',
  display: 'flex',
  margin: 'auto',
  color: '#33cccc',
  height: 15,
  padding: '0px !important',
  '& .MuiSlider-thumb': {
    height: 25,
    width: 25,
    backgroundColor: '#fff',
    boxShadow: '0 0 5px 0px rgba(0, 0, 0, 0.4)',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0 0 5px 0px rgba(0, 0, 0, 0.4)',
      // Reset on touch devices, it doesn't add specificity
    },
    '&:before': {
      boxShadow:
        '0 0 5px 0px rgba(0, 0, 0, 0.4)',
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'normal',
    top: -6,
    backgroundColor: 'unset',
    display: 'none',
    color: '#fff',
    '&::before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: '#222',
      fontSize: 25
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 15,
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#d0d0d0',
  },
});

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const bottomBtn = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 20px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  color: '#fff',
  width: '100%',
  borderRadius: '20px',
  mt: 3,
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
}

const editbtn = {
  width: '49%',
  alignItems: 'center'
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '90%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});